import {
    SettingsActionTypes,
    DriftmeldingLoadingAction,
    DriftmeldingLoadedAction,
    DriftmeldingSuccessAction,
    SettingsHideMaintenanceMessageAction,
    DriftmeldingApiResponse,
    DriftmeldingErrorAction,
    InfoBannerApiResponse,
    InfoBannerLoadingAction,
    InfoBannerLoadedAction,
    InfoBannerSuccessAction,
    InfoBannerErrorAction,
} from "./types"

export const actions = {
    /**
     * Initiates loading of the app settings.
     */
    loading: (): DriftmeldingLoadingAction => ({ type: SettingsActionTypes.DriftmeldingLoading }),
    loaded: (): DriftmeldingLoadedAction => ({ type: SettingsActionTypes.DriftmeldingLoaded }),
    success: (payload: DriftmeldingApiResponse): DriftmeldingSuccessAction => ({
        type: SettingsActionTypes.DriftmeldingSuccess,
        payload,
    }),
    error: (error: string | Error): DriftmeldingErrorAction => ({
        type: SettingsActionTypes.DriftmeldingError,
        error,
    }),
    hideMaintenanceMessage: (): SettingsHideMaintenanceMessageAction => ({
        type: SettingsActionTypes.HideMaintenanceMessage,
    }),

    infoBannerLoading: (): InfoBannerLoadingAction => ({
        type: SettingsActionTypes.InfoBannerLoading,
    }),
    infoBannerLoaded: (): InfoBannerLoadedAction => ({
        type: SettingsActionTypes.InfoBannerLoaded,
    }),

    infoBannerSuccess: (payload: InfoBannerApiResponse): InfoBannerSuccessAction => ({
        type: SettingsActionTypes.InfoBannerSuccess,
        payload,
    }),

    infoBannerError: (error: string | Error): InfoBannerErrorAction => ({
        type: SettingsActionTypes.InfoBannerError,
        error,
    }),
}
